import {
  Component,
  OnInit,
  ViewChildren,
  NgZone,
  OnDestroy,
} from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { MatLegacyAutocomplete as MatAutocomplete } from "@angular/material/legacy-autocomplete";
import { RateTableRequest } from "../model/rateTableRequest.model";
import { Group } from "../model/group.model";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { DataService } from "../shared/services/data.service";
import { of, from, Subject } from "rxjs";
import { RateTableInfo } from "../model/rateTableInformation.model";
import { AuthorizationService } from "../authorization/authoriation.service";
import "rxjs/add/operator/map";
declare let $: any;

import { debounceTime } from "rxjs/operators";
import { Broker } from "../model/brokerInformation.model";
import { User } from "../model/userInformation.model";
import { DisclaimerComponent } from "../disclaimer/disclaimer.component";
import { marketSegmentType } from "../model/enums/market-segment.enum";

import { BrowserUIService } from "../unsupported-browser-alert/browser-ui.service";
import { StateId } from "../model/enums/stateCode.enum";

@Component({
  selector: "app-group",
  templateUrl: "./group.component.html",
  styleUrls: ["./group.component.css"],
})
export class GroupComponent implements OnInit {
  brokerState: string;
  brokerId: number;
  group: Group = new Group();
  rateTableInfo: RateTableInfo = new RateTableInfo();
  groupform: UntypedFormGroup;
  groupNameDetailEvent = new Subject<string>();
  quotableDates: any = [];
  displayloader: boolean = false;
  loggedInUserId: number;
  selectedAgency: any;
  selectedSicCodeId: number;
  selectedGroupName: string;
  zipCodes: any[];
  groupDetails: any[];
  invalidSicCode: boolean = false;
  isSicSelected: boolean = true;
  invalidZipCode: boolean = false;
  showEffectiveDateError: boolean = false;
  tempEffectiveDate: string;
  brokerInfo: Broker = new Broker();
  rateTableRequest: RateTableRequest = new RateTableRequest();
  redirectUri = localStorage.getItem("redirectUrl");
  existingGroupId =
    localStorage.getItem("group_id") == null ||
    localStorage.getItem("group_id") == undefined
      ? -1
      : parseInt(localStorage.getItem("group_id"));
  existingGroupDetails: any;
  sicCodes: any[]; //SIC Code list for auto-population
  isMenuOpen: boolean = false;
  screenWidth: number;
  userInfo: User = new User();
  Id: number = 0;
  MarketSegmentTypeId: number = marketSegmentType.Group;
  brokerLicensedStates:string; 
  @ViewChildren(MatAutocomplete) matAutocomplete: MatAutocomplete;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: UntypedFormBuilder,
    private dataService: DataService,
    private route: ActivatedRoute,
    private authorizationService: AuthorizationService,
    private browserUiService: BrowserUIService,
    private ngZone: NgZone,
    private dialog: MatDialog
  ) {
    localStorage.setItem("rate_table_id", route.snapshot.params["Id"]);
    this.loggedInUserId = this.authorizationService.userId;

    this.userInfo.FullName = this.authorizationService.FullName;
    this.userInfo.Email = this.authorizationService.email;
    this.userInfo.UserRole = this.authorizationService.userRole;
    this.screenWidth = window.innerWidth;

    window.onresize = () => {
      // set screenWidth on screen size change
      this.screenWidth = window.innerWidth;
    };
  }

  ngOnInit() {
    this.brokerInfo.Name = this.dataService
      .getValueFromLocalstorage("broker_name")
      .replace(/%20/g, " ");
    this.brokerInfo.License = this.dataService.getValueFromLocalstorage(
      "broker_LicenseNumber"
    );
    this.brokerInfo.Phone =
      this.dataService.getValueFromLocalstorage("broker_Phone");
    this.brokerInfo.SalesRep = this.dataService
      .getValueFromLocalstorage("salesRepName")
      .replace(/%20/g, " ");
    this.brokerInfo.SalesRepEmail =
      this.dataService.getValueFromLocalstorage("salesRepEmail");
    this.brokerInfo.Email = this.dataService.getValueFromLocalstorage("email");
    this.brokerInfo.TierDescription = this.dataService.getValueFromLocalstorage(
      "broker_tier_description"
    );
    this.brokerState =
      this.dataService.getValueFromLocalstorage("broker_state");
    this.brokerId = Number(
      this.dataService.getValueFromLocalstorage("broker_id")
    );
    this.groupform = this.groupDetail();
    this.spinner.show();
    this.groupNameDetailEvent.pipe(debounceTime(500)).subscribe((val) => {
      this.getGroupDetails(val);
    });
    this.brokerState = localStorage.getItem("broker_state");
    this.Id = Number(this.dataService.getValueFromRoute(this.route, "Id"));
    this.getAgencyDetails(this.brokerId);
    this.getQuotableDates();
    this.openDisclaimerPopup();
    this.checkAndSetBrokerLicensedStates(this.authorizationService.userId);
    if (localStorage.getItem("IsTermsAccepted") == "true") {
      // show this after the user accept the Disclaimer
      this.browserUiService.checkBrowserSupport();
    }
  }

  isSelectedEffectiveDate(quotableDate) {
    if (
      this.group.EffectiveDate != "" &&
      this.group.EffectiveDate != undefined &&
      this.group.EffectiveDate != null
    ) {
      let value = new Date(quotableDate);
      var date =
        value.getDate() < 10
          ? "0" + value.getDate().toString()
          : value.getDate().toString();
      var month =
        value.getMonth() + 1 < 10
          ? "0" + (value.getMonth() + 1).toString()
          : (value.getMonth() + 1).toString();
      var fullDate = month + "/" + date + "/" + value.getFullYear();
      return (
        this.group.EffectiveDate == quotableDate ||
        this.group.EffectiveDate == fullDate
      );
    }
    return false;
  }
  checkAndSetBrokerLicensedStates(userId: number): void {
    const brokerStates = this.dataService.getValueFromLocalstorage("broker_licensed_states");
    if (brokerStates) {
      this.brokerLicensedStates = brokerStates;
      return;
    }
    this.fetchBrokerAccountsAndSetStates(userId);
  }
  
  private fetchBrokerAccountsAndSetStates(userId: number): void {
    this.dataService.getUserInformation(userId).subscribe({
      next: result => {
        const brokers = result?.Brokers;
  
        if (Array.isArray(brokers) && brokers.length > 0) {
          const brokerState = this.dataService.getBrokerLicensedStates(brokers);
  
          if (brokerState) {
            localStorage.setItem("broker_licensed_states", brokerState);
            this.brokerLicensedStates = brokerState;
          }
        }
      },
      error: err => {
        console.error("Error fetching broker account info:", err);
      }
    });
  }
  
  
  getQuotableDates() {
    //check entered zipcode is of 5 digits and zipcode list has values
    if (this.brokerState == undefined) {
      this.quotableDates = [];
      this.group.EffectiveDate = "";
      return;
    }

    this.displayloader = true;
    //call api for QuotableDates based on stateId
    this.dataService
      .getQuotableDates(Number(this.brokerState))
      .subscribe((result) => {
        this.displayloader = false;
        for (let i = 10; i >= 1; i--) {
          let d = new Date();
          d.setDate(1);
          d.setMonth(d.getMonth() - i);
          let previousTenMonthsEffectiveDate =
            d.getMonth() + 1 + "/" + 1 + "/" + d.getFullYear();
          //The previous 10 effective date months from the current month
          this.quotableDates.push(previousTenMonthsEffectiveDate);
        }
        //All months turned on for quoting based on Role and State
        this.quotableDates.push(...result);
        //distinct quotableDates
        this.quotableDates = this.quotableDates.filter(
          (el, i, a) => i === a.indexOf(el)
        );
        //sort quotableDates
        this.quotableDates = this.quotableDates.sort((date1, date2) => {
          return <any>new Date(date1) - <any>new Date(date2);
        });
      });
  }
  getAgencyDetails(brokerId: number) {
    this.dataService.getAgencyDetails(brokerId).subscribe((result) => {
      if (this.brokerState) {
        this.selectedAgency = result.find(
          (a) => a.LicenseStateId == this.brokerState
        );
        this.group.AgencyName = this.selectedAgency.Name;
        this.group.AgencyId = this.selectedAgency.Id;
      } else {
        this.group.AgencyName = result[0].Name;
        this.group.AgencyId = result[0].Id;
      }

      this.getRateTableDetail();
    });
  }
  getRateTableDetail(): any {
    if (this.Id > 0) {
      this.dataService.getRateTableDatabyId(this.Id).subscribe((result) => {
        if (result && result.Id > 0) {
          this.rateTableRequest = result;
          this.rateTableInfo = JSON.parse(this.rateTableRequest.RequestJson);
          this.group = this.rateTableInfo.Group;
          if (this.rateTableInfo.Carrier.nqsCarrierId) {
            this.dataService.activateNetworkNav.next(true);
          }
          if (this.group.SicCode != undefined) {
            this.isSicSelected = true;
          }

          if (result.GroupId == this.existingGroupId) {
            this.getExistingGroupDetails();
          } else {
            this.existingGroupId = this.group.GroupId;
            this.existingGroupDetails = this.group;
            this.selectedGroupName = this.group.groupName;
            this.selectedSicCodeId = this.group.SICCodeId;
          }
        } else {
          this.group = new Group();
        }
      });
    }
    this.spinner.hide();
  }
  setCounty(postalCode) {
    this.group.CountyCode = postalCode.CountyCode;
    this.group.CountyName = postalCode.County;
  }
  selectFirstCodeOnTab = function () {
    this.matAutocomplete.last.options.first.select();
  };
  getGroupDetails(searchText: string) {
    if (
      !searchText ||
      searchText.trim() == "" ||
      searchText == null ||
      searchText.length < 3
    )
      return;
    this.displayloader = true;

    if (this.selectedGroupName && this.selectedGroupName != searchText) {
      this.group.SicCode = "";
      this.group.GroupId = 0;
      this.selectedSicCodeId = 0;
      this.group.ZipCode = "";
      this.group.EffectiveDate = "";
      this.zipCodes = [];
      this.selectedSicCodeId = 0;
    }

    this.dataService
      .getGroupDetails(searchText, this.brokerId, this.MarketSegmentTypeId)
      .subscribe((result) => {
        this.groupDetails = result;
        this.displayloader = false;
      });
  }
  groupDetail(): UntypedFormGroup {
    return this.fb.group({
      groupId: 0,
      groupName: ["", Validators.required],
      zipCode: [
        "",
        [Validators.required, Validators.minLength(5), Validators.maxLength(5)],
        this.validateZipCodeRange.bind(this),
      ],
      sicCode: ["", Validators.required, this.validateSicCodeRange.bind(this)],
    });
  }

  IsCountyZipCodeSet() {
    return Boolean(
      this.group.ZipCode && this.group.CountyCode && this.group.CountyName
    );
  }

  isZipCodesDifferent(OldZipCodes, newZipCodes) {
    if (!OldZipCodes) {
      return OldZipCodes;
    }
    return !(
      OldZipCodes.filter(
        (oldZip) => newZipCodes.filter((newZip) => newZip === oldZip).length > 0
      ).length > 0
    );
  }

  validateZipCodeRange(control: UntypedFormControl) {
    return this.dataService.getPostalDetails(control.value).map((result) => {
      if (result.length == 0) return { zipCodeValidError: true };
      let isZipCodeDifferent = this.isZipCodesDifferent(this.zipCodes, result);
      const licensedStates = (this.brokerLicensedStates?.split(',') || []).map(s => Number(s.trim())); 
      const stateId = StateId[result[0].StateCode as keyof typeof StateId];
      this.zipCodes = result;
      if (
        this.zipCodes &&
        this.zipCodes.length > 0 &&
        (!this.IsCountyZipCodeSet() || isZipCodeDifferent)
      ) {
        this.group.ZipCode = this.zipCodes[0].ZipCode;
        this.group.CountyCode = this.zipCodes[0].CountyCode;
        this.group.CountyName = this.zipCodes[0].County;
        this.group.StateCode=this.zipCodes[0].StateCode;
      }
      if (result.length > 1) {
        this.group.IsMulticountyZip = true;
      } else {
        this.group.IsMulticountyZip = false;
      }
      if (!licensedStates.includes(stateId)) {
        return {
          zipCodeStateValidError: true,
        };
      }
      this.spinner.hide();
      return null;
    });
  }
  validateSicCodeRange(control: UntypedFormControl) {
    return of(this.invalidSicCode ? { sicCodeInValidError: true } : null);
  }

  onGroupSelect(groupDetail) {
    this.selectedGroupName = groupDetail.Name;
    this.group.groupName = groupDetail.Name;
    this.group.GroupId = groupDetail.Id;
    this.group.SicCode =
      groupDetail.SICCodeDetail + "(" + groupDetail.SICDescription + ")";
    this.selectedSicCodeId = groupDetail.SICCode;
    this.group.ZipCode = groupDetail.ZipCode;
    this.existingGroupDetails = groupDetail;
    this.existingGroupId = groupDetail.Id;
    this.invalidSicCode = false;
    this.isSicSelected = true;
    this.group.IsNewGroup = false;
    this.dataService
      .getPostalDetails(this.group.ZipCode)
      .subscribe((result) => {
        this.zipCodes = result;
      });
  }
  getExistingGroupDetails() {
    if (this.existingGroupId > 0) {
      this.dataService
        .getExistingGroupDetails(this.existingGroupId)
        .subscribe((result) => {
          if (result) {
            this.existingGroupDetails = result;
            this.selectedSicCodeId = result.SICCode;
            this.group.CountyCode = result.CountyCode;
            this.group.GroupId = result.Id;
            this.group.SicCode =
              result.SICCodeDetail + "(" + result.SICDescription + ")";
            this.group.SICCodeId = result.SICCode;
            this.group.SicCodeDetail = result.SICCodeDetail;
            this.group.SicDescription = result.SICDescription;
            this.group.ZipCode = result.ZipCode;
            this.group.groupName = result.Name;
            this.selectedGroupName = result.Name;
            this.spinner.hide();
          }
        });
    } else {
      this.spinner.hide();
    }
  }

  getSICCodes(searchText: string) {
    if (this.isSicSelected) {
      this.isSicSelected = false;
      return;
    }
    if (!searchText || searchText.toString().trim() == "") {
      this.sicCodes = [];
      return;
    }
    if (this.existingGroupId <= 0) this.invalidSicCode = true;

    this.dataService
      .getSICCodes(this.removeSpecialCharacters(searchText))
      .subscribe((result) => {
        if (result == null || result.length == 0) this.invalidSicCode = true;
        this.sicCodes = result;
      });
  }
  setSicCodeOnBlur() {
    if (this.sicCodes != undefined && this.sicCodes.length == 1) {
      this.onSicCodeSelect(this.sicCodes[0]);
    }
  }
  setSicCode(obj) {
    return obj.Code + "(" + obj.Description + ")";
  }
  removeSpecialCharacters(str: string) {
    return str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, "").replace(/\s/g, "");
  }
  onSicCodeSelect(obj) {
    this.isSicSelected = true;
    this.selectedSicCodeId = obj.Id;
    this.group.SicCode = obj.Code + "(" + obj.Description + ")";
    this.invalidSicCode = false;
    this.isSicSelected = true;
  }
  saveGroupinfo() {
    this.showEffectiveDateError = true;
    if (
      this.groupform.valid &&
      this.group.EffectiveDate != null &&
      this.group.EffectiveDate != ""
    ) {
      this.spinner.show();
      this.showEffectiveDateError = true;
      this.saveGroup();
    } else {
      this.markFormGroupTouched(this.groupform);
    }
  }
  saveGroup(): void {
    let effectiveDate;
    if (this.tempEffectiveDate) {
      effectiveDate = this.group.EffectiveDate = this.tempEffectiveDate;
    } else {
      effectiveDate =
        this.existingGroupDetails == undefined
          ? this.group.EffectiveDate
          : this.existingGroupDetails.EffectiveDate;
    }
    let groupObj = {
      Id: this.group.GroupId,
      Name: this.group.groupName,
      SICCode: this.selectedSicCodeId,
      ClassificationTypeId: 1, //for All
      GroupStatusTypeId: -1,
      MedicareTypeId: 2,
      CensusEnvironmentTypeId: this.group.GroupId <= 0 ? 0 : 0, //set a new environment for NHWS
      AgencyId:
        this.group.GroupId > 0
          ? Number(this.group.AgencyId)
          : this.selectedAgency.AgencyId,
      AgencyName: this.group.AgencyName,
      BrokerId: Number(this.brokerId),
      CountyCode: this.group.CountyCode,
      ZipCode: this.group.ZipCode,
      EffectiveDate: effectiveDate, //no need to update Master Group
      MarketSegmentTypeId: this.MarketSegmentTypeId, // it will be always 2 because it belongs to smal group
    };
    this.dataService.saveGroupDetails(groupObj).subscribe((result) => {
      this.rateTableInfo.Broker = this.brokerInfo;
      this.rateTableInfo.UserInfo = this.userInfo;
      localStorage.setItem("group_id", result);
      this.group.SICCodeId = this.selectedSicCodeId;
      this.rateTableInfo.Group = this.group;
      this.rateTableRequest.GroupId = this.rateTableInfo.Group.GroupId = result;
      this.rateTableRequest.RequestJson = JSON.stringify(this.rateTableInfo);

      this.dataService
        .saveRateTableInfo(this.rateTableRequest)
        .subscribe((result) => {
          if (result && Number(result) > 0) {
            {
              this.spinner.hide();
              this.router.navigateByUrl("/carrier/" + result);
            }
          }
        });
    });
  }
  addNoScrollBackground() {
    this.isMenuOpen = true;
  }

  removeNoScrollBackground() {
    this.isMenuOpen = false;
  }

  public markFormGroupTouched(formGroup: UntypedFormGroup) {
    let objectValues = (obj) => {
      return Object.keys(obj).map((e) => obj[e]);
    };
    objectValues(formGroup.controls).forEach((control) => {
      control.markAsTouched();
    });
  }

  openDisclaimerPopup() {
    let showPopup = true;

    // don't show disclaimer, if redirected from WBQuote, QuoteLite, or Broker mobile apps
    if (showPopup) {
      let fromApp = localStorage.getItem("FromApp");
      if (fromApp == "wbquote" || fromApp == "quotelite" || fromApp == "bma") {
        showPopup = false;
      }
    }

    // don't show disclaimer, if the user has already agreed to the disclaimer (shown on this website).
    if (showPopup) {
      let wasAccepted =
        localStorage.getItem("IsTermsAccepted") == "true" ||
        this.dataService.IsTermsAccepted;
      if (wasAccepted) {
        showPopup = false;
      }
    }

    // don't show disclaimer, if groupId is specified.
    if (showPopup && this.existingGroupId > 0) {
      showPopup = false;
    }

    // show the popup disclaimer if needed
    if (showPopup) {
      this.router.navigateByUrl("/disclaimer");
    }
  }
}
